<template>
  <div class="personal">
    <div
      class="personal_tips"
      v-if="$store.state.simpleData.authType == 'ACCOUNT'"
    >{{$t('message.search_personal_tips')}}</div>
    <el-form :model="form" class="personal_form" hide-required-asterisk>
      <el-form-item :label="$t('message.spNo')">
        <el-input v-model="form.spNo" disabled></el-input>
      </el-form-item>
    </el-form>
    <GradientBtn
      v-if="$store.state.simpleData.authType == 'ACCOUNT' && !['HZMB_FIRST_PERSON','HZMB_FIRST_COMPANY','HZMB_RENEW_PERSON','HZMB_RENEW_COMPANY'].includes(serviceType)"
      class="personal_btn"
      @click="account"
    >{{$t('message.Verification.personal.onePass_verify')}}</GradientBtn>
    <GradientBtn
      class="personal_btn"
      @click="$router.push('/search/personal/phone')"
    >{{$t('message.Verification.personal.phone_verify')}}</GradientBtn>
  </div>
</template>

<script>
// import { basePath } from "../../api/axios";
import GradientBtn from "../../components/GradientBtn";
import util from "@/util/util";
const { splicingAccountLogin } = util;
export default {
  components: { GradientBtn },
  data() {
    return {
      basePath: "",
      serviceType: ''
    };
  },
  computed: {
    form: {
      get() {
        return this.$store.state.verifyForm;
      },
      set(value) {
        this.$store.commit("changeVerifyForm", value);
      },
    },
  },
  methods: {
    account() {
      // localStorage.setItem("entryType", "search");
      this.$store.commit("changeViewType", "search");
      localStorage.setItem("entryType", "search");
      // this.$router.push("/search/status");
      const serviceType = localStorage.getItem("serviceType") || null;

      const accountToken = sessionStorage.getItem("accountToken") || null;
      if (accountToken) {
        return;
      } else {
        window.location.href = splicingAccountLogin(serviceType);
      }
    },
  },
  created() {
    this.serviceType = this.$route.query.serviceType || localStorage.getItem("serviceType") || null;
    this.basePath = process.env.VUE_APP_BASE_RESOURCE_PATH;
  },
};
</script>

<style lang="scss" scoped>
.personal {
  margin: auto;
  text-align: center;
  height: 500px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  .personal_form {
  }
}
.personal_btn {
  margin-top: 34px;
  margin-left: auto;
  margin-right: auto;
  width: 430px;
  max-width: 100%;
}
.gradient_btn {
  width: 300px;
  max-width: 100%;
}
.gradient_btn_pt {
  width: 400px;
}
</style>
<style lang="scss">
.personal_tips {
  width: 254px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(85, 85, 85, 1);
  line-height: 20px;
  margin: 16px auto;
  text-align: center;
}
</style>